export enum RULER_BAR_EVENTS {
    ON_SHOW_CHANGED = 'show-ruler-bar-changed-event',
}
// localStorage 里保存「是否显示标尺」的 key
export const SHOW_RULER_BAR_STORAGE_KEY = 'show-editor-ruler-bar__';
// 标尺的宽高（水平高度、垂直宽度）
export const RULER_BAR_SIZE = 24;
